import React from 'react'
import { spacing, colors } from '../../foundation'

export const CenteredContent: React.FunctionComponent<{ className?: string }> = ({
  children,
  ...props
}) => (
  <div css={{ backgroundColor: colors.GRAYSCALE.X10 }} {...props}>
    <div
      css={{
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingTop: spacing.X24,
        paddingBottom: spacing.X24,
        gap: spacing.X24,
        width: 720,
      }}
    >
      {children}
    </div>
  </div>
)
